import { SVGProps } from 'react';

const SvgCheckboxUnchecked = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
        <rect width={19} height={19} x={0.5} y={0.5} rx={3.5} />
    </svg>
);
export default SvgCheckboxUnchecked;
